/**
 * @prop --transition-duration: Duration of the pulse. Defaults to 300ms.
 * @prop --counter-background-color: The background color. Defaults to --foreground-color. Inverts the parent foreground / background relationship.
 * @prop --counter-foreground-color: The foreground color. Defaults to --background-color. Inverts the parent foreground / background relationship.
 */

:host {
    --transition-duration: 300ms;
    --background-color: inherit;
    --foreground-color: inherit;
    --counter-background-color: var(--foreground-color, var(--color-contrast));
    --counter-foreground-color: var(
        --background-color,
        var(--color-background)
    );

    display: flex;
    align-items: center;
    justify-content: center;

    transition-duration: 300ms;

    transition-duration: var(--transition-duration);
    transition-property: transform;
    transition-timing-function: ease;
    transform: scale(1);
}

:host rect {
        fill: var(--counter-background-color);
        stroke: var(--counter-background-color);
        stroke-width: 2;

        transition-duration: var(--transition-duration);
        transition-property: fill, stroke;
        transition-timing-function: ease;
    }

:host text {
        font-size: 13px;
        font-weight: 700;
        fill: var(--counter-foreground-color);

        transition-duration: var(--transition-duration);
        transition-property: fill;
        transition-timing-function: ease;
    }

:host(.okay) {
    --counter-background-color: var(--color-info);
    --counter-foreground-color: var(--color-info-contrast);
}

:host(.warning) {
    --counter-background-color: var(--color-warning);
    --counter-foreground-color: var(--color-warning-contrast);
}

:host(.error) {
    --counter-background-color: var(--color-error);
    --counter-foreground-color: var(--color-error-contrast);
}

:host(.pulse) {
    transform: scale(1.1);
}

:host([variant='outline']) {
    background-color: transparent;
}

:host([variant='outline']) rect {
        fill: transparent;
    }

:host([variant='outline']) text {
        font-weight: 600;
        fill: var(--counter-background-color);
    }

:host([variant='minimal']) {
    background-color: transparent;
}

:host([variant='minimal']) rect {
        fill: transparent;
        stroke: transparent;
    }

:host([variant='minimal']) text {
        font-weight: 600;
        fill: var(--counter-background-color);
    }
